import React from 'react';
import {
  PremiumIcon,
  BusinessIcon,
  SmileIcon,
  MoneyIcon,
  QueenBedNew,
  XXKTvNew,
  NightstandNew,
  KingBedNew,
  PanoramicCornerWindowsNew,
  ExtraFloorSpaceNew,
  SofaChairNew,
  RoomWithAView,
  TwinBed,
  MostAffordableOption,
} from 'assets/icons';

type RoomOptionAttribute = {
    icon: React.ReactElement;
    text: string;
  };
  
  type RoomOption = {
    id: string,
    title: string;
    description: string;
    titleIcon: React.ReactElement;
    capacity: number;
    attributes: RoomOptionAttribute[];
    hasWindow: boolean;
  };

  export const ROOM_TYPE_OPTIONS: Record<string, RoomOption> = {
  King: {
    id: "793ba336-7888-43fd-912d-3d32285d9722",
    title: 'Enjoy the luxury of the king suite',
    description: 'Travel in style with this premium option',
    titleIcon: <PremiumIcon />,
    capacity: 2,
    attributes: [
      { icon: <KingBedNew />, text: '1 King bed' },
      { icon: <XXKTvNew />, text: '55" 4K TV' },
      { icon: <NightstandNew />, text: 'Nightstand' },
      { icon: <PanoramicCornerWindowsNew />, text: 'Panoramic corner windows' },
      { icon: <ExtraFloorSpaceNew />, text: 'Extra floor space' },
      { icon: <SofaChairNew />, text: 'Sofa chair' },
    ],
    hasWindow:  true
  },

  Queen: {
    id: "a46c184f-b369-46d4-9f53-b9aa71702a29",
    title: 'Relax and stream in style',
    description: 'Best for the business traveller',
    titleIcon: <BusinessIcon />,
    capacity: 2,
    attributes: [
      { icon: <QueenBedNew />, text: '1 Queen bed' },
      { icon: <XXKTvNew />, text: '50" 4K TV' },
      { icon: <NightstandNew />, text: 'Nightstand' },
      { icon: <SofaChairNew />, text: 'Sofa chair' },
      { icon: <RoomWithAView />, text: 'Room with a view' },
    ],
    hasWindow:  true
  },

  Rook: {
    id: "60be735a-917f-4f1c-9683-2b0db34637b2",
    title: 'Regular room',
    description: 'Affordable and cheerful',
    titleIcon: <SmileIcon />,
    capacity: 1,
    attributes: [
      { icon: <QueenBedNew />, text: '1 Queen bed' },
      { icon: <XXKTvNew />, text: '43" 4K TV' },
      { icon: <NightstandNew />, text: 'Nightstand' },
    ],
    hasWindow:  true
  },

  Knight: {
    id: "7530c620-8a96-4d25-891c-f8af0fee7019",
    title: 'Regular room',
    description: 'Cheap and cheerful',
    titleIcon: <SmileIcon />,
    capacity: 2,
    attributes: [
      { icon: <QueenBedNew />, text: '1 Queen bed' },
      { icon: <XXKTvNew />, text: '43" 4K TV' },
      { icon: <NightstandNew />, text: 'Nightstand' },
    ],
    hasWindow:  true

  },

  'Rook Inside': {
    id: "a73cfe72-7ff6-42ef-b8da-e1a93fa909b8",
    title: 'Regular room',
    description: 'Affordable and cheerful',
    titleIcon: <SmileIcon />,
    capacity: 1,
    attributes: [
      { icon: <QueenBedNew />, text: '1 Queen bed' },
      { icon: <XXKTvNew />, text: '43" 4K TV' },
      { icon: <NightstandNew />, text: 'Nightstand' },
    ],
    hasWindow:  false
  },

  'Knight Inside': {
    id: "660c561e-2d65-4a7a-a53e-53b4e53a70c7",
    title: 'Regular room',
    description: 'Cheap and cheerful',
    titleIcon: <SmileIcon />,
    capacity: 2,
    attributes: [
      { icon: <QueenBedNew />, text: '1 Queen bed' },
      { icon: <XXKTvNew />, text: '43" 4K TV' },
      { icon: <NightstandNew />, text: 'Nightstand' },
    ],
    hasWindow:  false
  },

  'Pawn Inside': {
    id: "0f0fe499-b048-4ff8-bf25-513510c41f19",
    title: 'A minimal room with a twin bed',
    description: 'For the frugal minimalist',
    titleIcon: <MoneyIcon />,
    capacity: 1,
    attributes: [
      { icon: <TwinBed />, text: '1 Twin bed' },
      { icon: <XXKTvNew />, text: '43" 4K TV' },
      { icon: <MostAffordableOption />, text: 'Most affordable option' },
    ],
    hasWindow:  false
  },

  'Bishop Inside': {
    id: "80bcaaf3-f9e2-4656-98c9-7fab704cb0ae",
    title: 'A minimal room with a twin bed',
    description: 'For the frugal minimalist',
    titleIcon: <MoneyIcon />,
    capacity: 1,
    attributes: [
      { icon: <TwinBed />, text: '1 Twin bed' },
      { icon: <XXKTvNew />, text: '43" 4K TV' },
      { icon: <MostAffordableOption />, text: 'Most affordable option' },
    ],
    hasWindow:  false
  },
};

export const roomPairs: Record<string, { noWindow: string; window: string }> = {
  'Rook Inside': { noWindow: 'Rook Inside', window: 'Rook' },
  'Knight Inside': { noWindow: 'Knight Inside', window: 'Knight' },
  'Rook': { noWindow: 'Rook Inside', window: 'Rook' },
  'Knight': { noWindow: 'Knight Inside', window: 'Knight' },
  'Bishop Inside': { noWindow: 'Bishop Inside', window: 'Pawn Inside' },
  'Pawn Inside': { noWindow: 'Bishop Inside', window: 'Pawn Inside' },
};